import { useTheme } from "components/common/Context/ThemeContext"
import PropTypes from "prop-types"
import React from "react"
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa"
import ReactStars from "react-rating-stars-component"

export default function Rating({ value, onChange }) {
  const theme = useTheme()
  return (
    <ReactStars
      size={20}
      count={5}
      edit
      value={value}
      onChange={onChange}
      activeColor={theme.starFilled}
      emptyIcon={<FaRegStar className="mr-2" data-testid="empty-rating-icon" />}
      halfIcon={
        <FaStarHalfAlt className="mr-2" data-testid="half-rating-icon" />
      }
      filledIcon={<FaStar className="mr-2" data-testid="full-rating-icon" />}
    />
  )
}

Rating.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func
}
